import { FILTER } from '@fiverr-private/listing_lib';

/**
 * Filters whose activeFilters value is a single scalar (e.g. 'any'/'true') instead of an array of
 * option ids. Their option id equals the filter id.
 */
const SCALAR_VALUE_FILTERS: Record<string, string> = {
    [FILTER.PRO.ID]: FILTER.PRO.SELECTED_VALUE,
};

export const isScalarValueFilterId = (filterId: string): boolean => filterId in SCALAR_VALUE_FILTERS;

export const getScalarFilterValue = (filterId: string): string => SCALAR_VALUE_FILTERS[filterId];
